import React, { useEffect, useState } from "react";
import BlogSilder from "../../BlogsFeature/components/BlogSilder";
import { useNavigate, useParams } from "react-router-dom";
import CoachesCard from "../Coaches/components/CoachesCard";
import { get_feature_overview } from "../../../../DAL/features/features";
import { enqueueSnackbar } from "notistack";
import RecordNotFound from "../../../../components/recordNotFound/RecordNotFound";
import CircularLoader from "../../../../components/loader/CircularLoader";
import { show_proper_words } from "../../../../utils/Constant";
import ClientsCard from "../../../clientTypes/components/ClientsCard";
import CompanyPopup from "../../../../components/popUp/CompanyPopup";
import { useIds } from "../../../../hook/AdminContext";
import CommingSoon from "../../../../components/recordNotFound/CommingSoon";

export default function OverViewPage({
  setCardToOpen,
  overViewType,
  companyType,
  contentData,
  handleEditProfile = null,
  handleOpenCoachDialog = () => {},
  setSelectedCoach = () => {},
}) {
  const params = useParams();
  const { userInfo, handleGetSectorAccessValue } = useIds();
  const navigate = useNavigate();
  const { source_slug, type_slug, feature_slug } = params;
  const [loading, setLoading] = useState(true);
  const [openDetails, setOpenDetails] = useState(false);
  const [targetCompany, setTargetCompany] = useState(null);

  const [blogsList, setBlogsList] = useState([]);

  const [userListing, setUserListing] = useState([]);
  console.log(userListing, "userListinguserListing");

  const handleNavigate = () => {
    setCardToOpen(overViewType);
  };

  const handleGetOverviewData = async () => {
    setLoading(true);
    const resp = await get_feature_overview(source_slug, feature_slug);
    console.log(resp, "respppppp");
    if (resp.code == 200) {
      setBlogsList(resp.data.blog);
      if (overViewType == "coach") {
        setUserListing(resp.data.coaches);
      } else {
        setUserListing(resp.data.profiles);
      }
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
      setUserListing([]);
    }
    setLoading(false);
  };

  const handleInsightClick = (blog) => {
    navigate(
      `/${source_slug}/feature/${feature_slug}/insight-details/${blog.slug}`,
      {
        state: { blog: blog },
      }
    );
  };

  const handleOpenEditCoach = (coach) => {
    setSelectedCoach(coach);
    handleOpenCoachDialog(true, handleGetOverviewData);
  };

  useEffect(() => {
    if (overViewType) {
      handleGetOverviewData();
    }
  }, [overViewType]);

  if (loading) {
    return <CircularLoader />;
  }
  return (
    <>
      {openDetails && (
        <CompanyPopup
          companyModalOpen={openDetails}
          handleCloseCompanyModal={() => setOpenDetails(false)}
          companyModalData={targetCompany}
          isCompanyProfile={true}
          companyType={companyType}
        />
      )}
      {blogsList.length > 0 && (
        <div className="overview-slider tw-pb-3">
          <BlogSilder
            slider_blogs={blogsList}
            handleDetails={handleInsightClick}
          />
        </div>
      )}
      {overViewType == "leader" && userListing.length == 0 ? (
        <>{blogsList.length == 0 ? <CommingSoon /> : ""}</>
      ) : (
        <div className="overview-coaches tw-my-4">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h6 className="mb-0">{contentData.sub_section_heading}</h6>
            {userListing?.length > 0 && (
              <button
                className="outlined-btn button-md"
                onClick={() => handleNavigate()}
              >
                View All {show_proper_words(contentData?.sub_section_heading)}
              </button>
            )}
          </div>

          {overViewType == "coach" || overViewType == "leader" ? (
            <>
              {userListing.length > 0 ? (
                <div className="row">
                  {userListing.map((item, index) => (
                    <>
                      <CoachesCard
                        item={item}
                        source_slug={source_slug}
                        type_slug={type_slug}
                        isCrudAllow={
                          handleGetSectorAccessValue("allow_manage_coach") &&
                          ((userInfo.role == "client" &&
                            !userInfo?.isCompanyProfile) ||
                            (userInfo?.isCompanyProfile &&
                              userInfo?.company_access?.manage_profile
                                ?.company_profile))
                        }
                        overViewType={overViewType}
                        handleOpenEditCoach={handleOpenEditCoach}
                        handleGetCoaches={handleGetOverviewData}
                        handleNavigateDetails={() => {}}
                      />
                    </>
                  ))}
                </div>
              ) : (
                <div>
                  <RecordNotFound
                    title={`No ${show_proper_words(overViewType)}`}
                  />
                </div>
              )}
            </>
          ) : (
            <>
              {userListing.length > 0 ? (
                <div className="row">
                  {userListing.map((item, index) => (
                    <>
                      <ClientsCard
                        item={item}
                        source_slug={source_slug}
                        type_slug={type_slug}
                        isCompanyProfile={true}
                        companyType={companyType}
                        handleNavigateDetails={(item) => {
                          setTargetCompany(item);
                          setOpenDetails(true);
                        }}
                        showDirectContactButton={true}
                        handleEditProfile={() =>
                          handleEditProfile(true, handleGetOverviewData)
                        }
                      />
                    </>
                  ))}
                </div>
              ) : (
                <div>
                  <RecordNotFound
                    title={`No ${show_proper_words(overViewType)}`}
                  />
                </div>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
}
